// Add more dummy customer feedbacks for an e-commerce platform selling electrical products
export const dummyfeedbacks = [
  {
    name: "John Munene",
    rating: 4.5,
    title: 'Quality Bulbs',
    comment: 'I purchased LED bulbs, and they are bright and energy-efficient. Quick delivery too!',
    date: '03-09-2023'
  },
  {
    name: "Mary Wanjiru",
    rating: 5,
    title: 'Great Bulb Holders',
    comment: 'The bulb holders I ordered were of excellent quality. They fit perfectly. Highly satisfied!',
    date: '03-08-2023'
  },
  {
    name: "Peter Kamau",
    rating: 4,
    title: 'Good Extension Cables',
    comment: 'The extension cables I bought were reliable and sturdy. They provide extra length when I need it.',
    date: '03-07-2023'
  },
  {
    name: "Grace Njeri",
    rating: 3,
    title: 'Decent Sockets',
    comment: 'I ordered electrical sockets, and they work fine. Not exceptional, but they get the job done.',
    date: '03-06-2023'
  },
  {
    name: "Daniel Otieno",
    rating: 4.5,
    title: 'Highly Recommend',
    comment: 'I purchased various electrical accessories, and they all met my expectations. Great selection!',
    date: '03-05-2023'
  },
  {
    name: "Lucy Achieng",
    rating: 4,
    title: 'Satisfied Customer',
    comment: 'The electrical cables I ordered were of good quality and reasonably priced. Easy shopping experience.',
    date: '03-04-2023'
  },
  {
    name: "Samuel Ndungu",
    rating: 2.5,
    title: 'Disappointed',
    comment: 'I ordered bulb sockets, but they arrived with a few defects. Customer support was slow to respond.',
    date: '03-03-2023'
  }
];

//conversations select status
export const convooptionsarray = [
  {
    label: "Pending",
    value: "pending"
  },
  {
    label: "Active",
    value: "active"
  },
  {
    label: "Completed",
    value: "completed"
  },
  {
    label: "All",
    value: ""
  },
]


//user types 
export const usertypes = ["Admin", "Agent"]